import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Attach bearer token fallback (for browsers blocking 3rd-party cookies)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("qaig_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
  if (detail.msg) return detail.msg;
  return String(detail);
}

export default api;
